import {
    ValidatorFn,
    AbstractControl,
    ValidationErrors,
    FormGroup,
} from '@angular/forms';

export function atLeastOneCheckboxSelectedValidator<T>(
    controlNames: (keyof T)[],
    errorKey: string,
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const formGroup = control as FormGroup;

        const isAtLeastOneSelected = controlNames.some((controlName) => {
            return formGroup.get(controlName as string)?.value === true;
        });

        return isAtLeastOneSelected ? null : { [errorKey]: true };
    };
}
